import { COLORS, TYPOGRAPHY } from 'Components/foundation';
import { createStyleSheet } from 'Components/foundation/stylesheets';

const styles = createStyleSheet({
  container: {
    width: 1000,
    margin: 'auto',
    marginTop: 32,
    gap: 60,
  },
  section: {
    display: 'flex',
    flexDirection: 'column',
    borderRadius: 4,
    backgroundColor: COLORS.WHITE.DEFAULT,
    padding: '60px 190px',
    gap: 40,
  },
  introBlock: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  campaignExplanationBlock: {
    display: 'flex',
    flexDirection: 'column',
    flexGrow: 1,
    gap: 6,
  },
  imagePickerBlock: {
    display: 'flex',
    flexDirection: 'column',
    gap: 10,
  },
  inputBlock: {
    display: 'flex',
    flexDirection: 'column',
    gap: 20,
  },
  disclaimerBlock: {
    marginLeft: 10,
    marginRight: 40,
  },
  title: {
    ...TYPOGRAPHY.H1,
    fontWeight: 'bold',
  },
  subTitle: {
    ...TYPOGRAPHY.BODY1,
  },
  comment: {
    ...TYPOGRAPHY.BODY3,
    color: COLORS.TEXT.SECONDARY_DEFAULT,
    whiteSpace: 'pre-wrap',
  },
  requiredFields: {
    ...TYPOGRAPHY.BODY3,
    margin: '24px 0',
  },
});

export default styles;
